/*
 * LoadingView Messages
 *
 * This contains all the text for the LoadingView component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    id: 'app.components.LoadingView.loading',
    defaultMessage: 'Loading ...',
  },
});
